// src/pages/LicenseList.js
import React, { useEffect, useState } from "react";
import { useAuthCheck } from "../components/Auth";
import { api } from "../components/Api";
import Loading from "../components/Loading";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

export default function LicenseList() {
    const [licenses, setLicenses] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const { checkToken } = useAuthCheck();

    useEffect(() => { checkToken(); }, [checkToken]);

    useEffect(() => {
        fetchLicenses();
    }, []);

    const fetchLicenses = async () => {
        setLoading(true);
        try {
            const res = await api.get("/license-cards");
            setLicenses(res.data);
        } catch (err) {
            console.error(err);
            alert("Erreur lors de la récupération des licences.");
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Voulez-vous vraiment supprimer cette licence ?")) return;

        try {
            await api.delete(`/license-cards/${id}`);
            alert("Licence supprimée avec succès.");
            setLicenses((prev) => prev.filter((l) => l.id !== id));
        } catch (err) {
            console.error(err);
            if (err.response?.status === 409) {
                alert("Impossible de supprimer cette licence car elle est utilisée par des produits.");
            } else {
                alert("Erreur lors de la suppression de la licence.");
            }
        }
    };

    const token = localStorage.getItem("token");

    if (!token || localStorage.getItem("role") > 2) {
        navigate("/");
    }

    return (
        <div className="container mx-auto p-6">
            <h1 className="text-2xl font-bold mb-4 dark:text-white">Liste des Licences (cartes)</h1>

            <button
                onClick={() => navigate("/add-license")}
                className="bg-blue-400 hover:bg-blue-500 text-white font-semibold rounded px-4 py-2 mb-4"
            >
                Ajouter une licence
            </button>

            {loading ? (
                <Loading message="Chargement des licences..." />
            ) : (
                <div className="overflow-x-auto">
                    <table className="w-full border-collapse border text-sm text-center">
                        <thead className="bg-gray-100 dark:bg-gray-800">
                            <tr>
                                <th className="border px-2 py-1">Nom de la licence (cartes)</th>
                                <th className="border px-2 py-1">Supprimer</th>
                            </tr>
                        </thead>
                        <tbody>
                            {licenses.map((license, index) => {
                                const bgColor = index % 2 === 0 ? "dark:bg-gray-600 bg-gray-050" : "dark:bg-gray-700 bg-gray-100";
                                return (
                                    <tr key={license.id} className={`${bgColor}`}>
                                        <td className="border px-2 py-1">{license.license_card}</td>
                                        <td className="border px-2 py-1">
                                            <button
                                                onClick={() => handleDelete(license.id)}
                                                className="text-red-500 hover:text-red-700 text-2xl"
                                            >
                                                <FontAwesomeIcon icon={faTrashCan} />
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}
